/* 🤖 this file was generated by svg-to-ts */
export const matIconShoppingBag: {
  name: 'shopping-bag';
  data: string;
} = {
  name: 'shopping-bag',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18 6h-2c0-2.21-1.79-4-4-4S8 3.79 8 6H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6-2c1.1 0 2 .9 2 2h-4c0-1.1.9-2 2-2zm6 16H6V8h2v2c0 .55.45 1 1 1s1-.45 1-1V8h4v2c0 .55.45 1 1 1s1-.45 1-1V8h2v12z"/></svg>`
};
